module.exports = __webpack_public_path__ + "img/Autumn-text.d9e87ab5.jpg";